<template>
  <div class="empty-component">
    <div class="empty-content">
      <img :src="require('@/assets/img/mall/no-order.png')" alt="empty" />
      <p class="empty-text">{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyComponent',
  props: {
    text: {
      type: String,
      default: '暂无相关信息'
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-component {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;

  .empty-content {
    text-align: center;

    img {
      width: 200px;
      margin-bottom: 20px;
    }

    .empty-text {
      color: #999;
      font-size: 14px;
    }
  }
}
</style>
